import { render } from "./templateAdd.vue?vue&type=template&id=e524de22&scoped=true"
import script from "./templateAdd.vue?vue&type=script&lang=js"
export * from "./templateAdd.vue?vue&type=script&lang=js"

import "./templateAdd.vue?vue&type=style&index=0&id=e524de22&lang=scss&scoped=true"
import "./templateAdd.vue?vue&type=style&index=1&id=e524de22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e524de22"]])

export default __exports__